import './FirstDuplicateOverlayContent.styl';
import { observer } from 'mobx-react-lite';
import { useTranslationsContext } from 'store/translations';
import Arrow from 'assets/img/smooth-arrow.svg';
import ArrowUp from 'assets/img/smooth-arrow-up.svg';
import { CollectionLink } from './CollectionLink';
import { useStoreContext } from 'store/app';

interface Props {
    duplicateSnakeId: number;
}

export const FirstDuplicateOverlayContent = observer(({ duplicateSnakeId }: Props) => {
    const { translate } = useTranslationsContext();
    const { isMob } = useStoreContext();

    return (
        <div className="third-day-overlay">
            <div className="third-day-overlay-title">{translate('third.day.overlay')}</div>
            <img className="third-day-overlay-arrow" src={isMob ? Arrow : ArrowUp}></img>
            <CollectionLink selectedSnake={duplicateSnakeId} className="third-day-overlay-button" />
        </div>
    );
});
